import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Confirm.cssmodule.less';
import { clickButton } from '../../actions/Modal';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';

class Confirm extends BaseComponent {
    constructor(props) {
        super(props);
        this.setConfirmTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    componentDidMount() {
        document.body.style.overflow = 'hidden';
        document.addEventListener('touchmove', this.preventDefault, {
            passive: false,
        });
        document.addEventListener('keyup', this.keyboardEvent);
    }

    componentWillUnmount() {
        document.body.style.overflow = 'auto';
        document.removeEventListener('touchmove', this.preventDefault, {
            passive: false,
        });
        document.removeEventListener('keyup', this.keyboardEvent);
    }

    keyboardEvent = (e) => {
        const { keyCode } = e;
        if (keyCode === 13) {
            this.handleButtonClick('ok');
        } else if (keyCode === 27) {
            this.handleButtonClick('cancel');
        }
    };

    preventDefault(e) {
        e.preventDefault();
    }

    setConfirmTheme(theme) {
        const themeStyle = this.getTheme(theme, 'CONFIRM');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    createContent(content) {
        let view = null;
        try {
            if (typeof content === 'object') {
                view = (
                    <div
                        className={`${Style.content} entrylmsAlertContent`}
                        dangerouslySetInnerHTML={{
                            __html: content.outerHTML,
                        }}
                    />
                );
            } else if (typeof content === 'string') {
                view = <div>{content}</div>;
            }
        } catch (e) {}

        return view;
    }

    render() {
        const { item = {} } = this.props;
        const { options = {} } = item;
        const {
            negativeButtonText = this.Utils.getLang('Buttons.cancel'),
            positiveButtonText = this.Utils.getLang('Buttons.course_done'),
        } = options;
        return (
            <div className={this.Style.confirm}>
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {this.props.item.title}
                </Title>
                <div className={this.Style.contentView}>
                    <div className={this.Style.content}>
                        {this.createContent(this.props.item.content)}
                    </div>
                    <div>
                        <Button
                            className={`${this.Style.button} ${
                                this.Style.cancelButton
                            }`}
                            text={negativeButtonText}
                            onClick={() => this.handleButtonClick('cancel')}
                        />
                        <Button
                            className={this.Style.button}
                            text={positiveButtonText}
                            onClick={() => this.handleButtonClick('ok')}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

Confirm.displayName = 'Confirm';
Confirm.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(Confirm);



// WEBPACK FOOTER //
// ./components/ModalSet/Confirm.js